import type { ColumnsType } from 'antd/lib/table'
import { CustomHeaderText } from 'src/components'

const failedOffsetsColumns: ColumnsType<any> = [
  {
    title: () => <CustomHeaderText text={'developers.OffSet.TransactionIdentifier'} />,
    dataIndex: 'country',
    render: (_, record) => {
      return (
        <span style={{ textAlign: 'center' }}>
          <strong>{record?.transaction_identifier}</strong>
        </span>
      )
    },
  },
  {
    title: () => <CustomHeaderText text={'general.ErrorTitle'} />,
    dataIndex: 'distanceKlm',
    render: (_, record) => {
      return (
        <span style={{ textAlign: 'center' }}>
          <strong>{record?.error}</strong>
        </span>
      )
    },
  },
]

export default failedOffsetsColumns
